import { Injectable } from '@angular/core';
import { Observable, Subject, timer, Subscription } from 'rxjs';
import { switchMap, takeUntil, shareReplay } from 'rxjs/operators';

const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root'
})
export class PollingService {

  private cache$: Observable<any>;
  private shouldStop$ = new Subject<void>();
  private subscription: Subscription;

  constructor(private timeout: number) { }

  start(executionBody: any, onSuccess: any, onFailure: any) {
    if (!this.cache$) {
      // Set up timer that ticks every X milliseconds
      const timer$ = timer(0, this.timeout);

      // For each tick make an http request to fetch new data
      this.cache$ = timer$.pipe(switchMap(executionBody),
        takeUntil(this.shouldStop$),
        shareReplay(CACHE_SIZE)
      );
    }
    this.subscription = this.cache$.subscribe((value) => onSuccess(value), (error) => onFailure(error));
  }

  stop() {
    this.shouldStop$.next();
    this.subscription.unsubscribe();
  }
}
